<template>
  <div id="staff-salary">
    <div class="table-container">
      <el-form
        class="info-table"
        label-position="right"
        label-width="180px"
        :model="salaryInfo"
      >
        <el-form-item label="计薪方式">
          <span>{{ salaryInfo.type === 1 ? '月薪' : '日薪' }}</span>
        </el-form-item>
        <el-form-item label="银行名称">
          <span>{{ salaryInfo.bank_name }}</span>
        </el-form-item>
        <el-form-item label="银行卡开户行信息">
          <span>{{ salaryInfo.bankcard_info }}</span>
        </el-form-item>
        <el-form-item label="银行卡号">
          <span>{{ salaryInfo.bankcard_num }}</span>
        </el-form-item>
        <el-form-item label="薪资">
          <span>{{ salaryInfo.salary }}</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { staffSalaryInfo } from '@/api/staff'
export default {
  name: 'Info',
  data () {
    return {
      salaryInfo: {}
    };
  },
  mounted () {
    this.getSalaryInfo()
  },
  methods: {
    async getSalaryInfo () {
      const { code, result } = await staffSalaryInfo()
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.salaryInfo = result
      }
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
.info-table {
  margin: 50px 400px;
}
</style>
<style>
.edit-item .el-form-item__content {
  display: flex;
}
</style>
